import styled from 'styled-components'
import ReactPlayer from 'react-player'

export const Player = styled(ReactPlayer)`
  display: flex;
`
